<template>
  <footer class="c-footer">
    <div class="container d-flex justify-content-center">
      <div class="d-flex flex-column flex-md-row my-3">
        <div class="mb-3 mb-md-0 me-md-4">
          <a
            href=""
            class="c-link"
            @click.prevent="$bvModal.show('modalTerms')"
          >
            Términos y condiciones
          </a>
        </div>
        <span class="d-none fs-25 w-light d-md-block me-md-4">
          I
        </span>
        <div class="mb-3 mb-md-0">
          <a
            href=""
            class="c-link"
            @click.prevent="$bvModal.show('modalPolitics')"
          >
            Políticas de privacidad
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>
